<template>
  <div>
    <div v-if="loading">
      <b-skeleton height="54px"/>
      <br>
      <b-skeleton height="54px"/>
    </div>
    <div v-if="!loading">
      <div v-if="error">
        <b-button disabled
                  size="is-danger is-fullwidth" icon-left="download">
          Failed to load downloads
        </b-button>
        <div class="is-size-7 has-text-centered is-italic">
          {{error}}
        </div>
        <div class="is-size-7 has-text-centered is-italic">
          Please try refreshing the page.
        </div>
      </div>
      <div v-else>
        <div v-if="latestRelease">
          <b-button @click="modalActive = true"
                    size="is-large is-primary is-fullwidth" icon-left="download">
            Download
          </b-button>
          <div v-if="latestRelease && latestRelease.version" class="is-small has-text-centered is-italic">
            Version: {{ latestRelease.version }}
          </div>
        </div>
        <b-button v-if="!latestRelease" disabled
                  size="is-large is-primary is-fullwidth" icon-left="download">
          Not yet available
        </b-button>
        <br>
        <b-button v-if="changelogUrl"
                  tag="a" :href="changelogUrl"
                  size="is-large is-fullwidth" icon-left="format-list-bulleted">
          Changelog
        </b-button>
        <br v-if="changelogUrl">
        <b-button v-if="sourceUrl"
                  tag="a" :href="sourceUrl"
                  size="is-fullwidth" icon-left="github">
          Source Code
        </b-button>
        <b-button v-if="devBuilds && devBuilds.url"
                  style="margin-top: 10px"
                  tag="a" :href="devBuilds.url"
                  size="is-fullwidth" :icon-left="devBuilds.icon">
          CI builds
        </b-button>
        <div v-if="devBuilds && devBuilds.tooltip"
             class="is-size-7 has-text-centered is-italic">
          {{ devBuilds.tooltip }}
        </div>
        <br>
        <b-button id="button-support"
            tag="a" href="https://ko-fi.com/sejsel"
                  size="is-fullwidth" icon-left="coffee" outlined>
          Support on Ko-fi
        </b-button>
        <br v-if="devBuilds && devBuilds.url">
      </div>
      <section>
        <b-modal v-if="latestRelease" :active.sync="modalActive" :width="800">
          <div class="modal-card" style="width: auto;">
            <header class="modal-card-head">
              <p class="modal-card-title">
                Downloads
              </p>
            </header>
            <section class="modal-card-body">
              <h2 class="title has-text-centered">{{programName}} {{latestRelease.version}}</h2>
              <h3 class="subtitle has-text-centered">Release date: {{ latestRelease.releaseDate }}</h3>
              <div class="columns">
                <div class="column" v-for="platform in latestRelease.platforms" :key="platform">
                  <h3 class="title has-text-centered">{{ platform.platformName }}</h3>
                  <div class="notification is-primary" v-for="download in platform.downloads" :key="download.name">
                    <b-button @click="modalActive = true"
                              type="is-primary"
                              size="is-large is-fullwidth"
                              inverted
                              :icon-left="download.icon"
                              tag="a" :href="download.url"
                    >
                      {{ download.name }}
                    </b-button>
                    <div class="is-small has-text-centered is-italic" style="margin-top: 10px">
                      {{ download.tooltip }}
                    </div>
                  </div>
                </div>
              </div>
              <b-button @click="modalActive = true"
                        type="is-primary"
                        size="is-large is-fullwidth"
                        inverted
                        icon-left="format-list-bulleted"
                        tag="a" :href="latestRelease.changelogUrl"
              >
                Changelog
              </b-button>
            </section>
            <footer class="modal-card-foot">
              <b-button @click="modalActive = false">Close</b-button>
            </footer>
          </div>
        </b-modal>
      </section>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ['releaseFeedUrl', 'programName'],
  name: "ProgramDownloads",
  data() {
    return {
      releaseData: {},
      modalActive: false,
      loading: true,
      error: null
    }
  },
  methods: {
    loadAsyncData() {
      axios.get(this.releaseFeedUrl, {
        baseURL: null
      }).then(response => {
        this.releaseData = response.data;
      }).catch(error => {
        this.releaseData = {};
        this.error = error;
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    this.loadAsyncData();
  },
  computed: {
    sourceUrl() {
      return this.releaseData.sourceUrl;
    },
    changelogUrl() {
      return this.releaseData.fullChangelogUrl;
    },
    devBuilds() {
      return this.releaseData.devBuilds;
    },
    releases() {
      return this.releaseData.releases;
    },
    latestRelease() {
      if (this.releases && this.releases.length > 0) {
        return this.releases[0];
      }
      return null;
    }
  }
}
</script>

<style>
#button-support {
  border-color: #f96853;
  color: #f96853;
  margin-top: 10px
}
#button-support:hover {
  background-color: #f96853;
  color: white;
  border-color: #f96853;
}
</style>